export type ClassValue = string | number | false | null | undefined;

/**
 * Minimal `classNames` join: drops falsy entries, space-joins the rest.
 * Keeps component call-sites readable without pulling in a dependency.
 */
export function cx(...values: ClassValue[]): string {
  return values.filter((v): v is string | number => Boolean(v)).join(' ');
}
